/* tslint:disable:react-a11y-anchors */
import * as React from 'react'

import BarChartIcon from '../../../shared/components/icons/barChart'
import ImagePreview from '../../../shared/components/imagePreview'
import MagnifierConfigurator from '../../../shared/components/magnifier/configurator'
import Overlay from '../../../shared/components/overlay'
import StarRating from '../../../shared/components/starRating'
import MetaCategories from '../../pages/search/result/metaCategories'
import ItemActions from './common/itemActions'
import TrendingSash from './common/trendingSash'

import { IItem } from '../../../../typings/searchResults'

const ItemCardListBigPreview = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {},
  muted,
  muteVideo
}: {
  item: IItem
  onAddToFavourites: () => void
  rank: number
  onAddToCollections?: any
  onItemLinkClick?: () => void
  onAddToCart?: () => void
  muted?: any
  muteVideo?: any
}) => {
  const marketingSrc = (currentItem: IItem) =>
    (currentItem.previews.landscape_preview &&
      currentItem.previews.landscape_preview.landscape_url) ||
    (currentItem.previews.icon_with_video_preview &&
      currentItem.previews.icon_with_video_preview.landscape_url)

  return (
    <div>
      <div className="product-list__columns-container">
        <div className="product-list__column-detail">
          <div className="product-list__item-thumbnail">
            <div className="item-thumbnail">
              <Overlay
                position="side"
                content={
                  <MagnifierConfigurator
                    item={item}
                    videoMuted={muted}
                    muteVideo={muteVideo}
                  />
                }
              >
                <div
                  className="item-thumbnail__image item-thumbnail__marketing"
                  data-test-selector="item-thumbnail-default"
                >
                  <a
                    href={`${item.url}?s_rank=${rank}`}
                    onClick={onItemLinkClick}
                    className="item-thumbnail__link"
                  >
                    <ImagePreview item={item} />
                  </a>
                  {item.previews.live_site ? (
                    <div className="item-thumbnail__preview">
                      <a
                        href={item.previews.live_site.url}
                        target="_blank"
                        className="item-thumbnail__preview-link"
                      >
                        Live preview
                      </a>
                    </div>
                  ) : null}
                </div>
              </Overlay>
            </div>
          </div>

          <div className="product-list__adjacent-thumbnail">
            <h3 className="product-list__heading">
              <a
                className="fds-c-text-link -color-inherit -decoration-reversed"
                href={`${item.url}?s_rank=${rank}`}
                onClick={onItemLinkClick}
              >
                {item.name}
              </a>
            </h3>

            <div className="product-list__price">
              <p className="fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0">
                ${item.ui.price}{' '}
                {item.ui.pricePeriod && (
                  <span className="fds-c-text-body -size-xs fds-u-m0">
                    /{item.ui.pricePeriod}
                  </span>
                )}
              </p>
            </div>

            <div className="product-list__info">
              <div className="product-list__info-author">
                <a
                  className="fds-c-text-link -color-default -decoration-reversed"
                  href={item.author_url}
                >
                  {item.author_username}
                </a>
              </div>

              <div className="product-list__column-category">
                <p className="fds-c-text-body -size-xs fds-u-m0">
                  <MetaCategories
                    classification={item.classification}
                    className="meta-categories -no-slash"
                  />
                </p>
              </div>

              <div className="product-list__info-rating">
                {item.rating.rating ? (
                  <StarRating
                    rating={item.rating.rating}
                    className="star-rating--search"
                  />
                ) : null}
                {item.rating.rating && item.rating.count
                  ? `${item.rating.count} ratings`
                  : null}
              </div>

              {item.number_of_sales ? (
                <div className="product-list__info-sale">
                  <span className="product-list__info-sale-glyph">
                    <BarChartIcon />
                  </span>
                  {item.number_of_sales} Sales
                </div>
              ) : null}

              <div className="product-list__item-thumbnail-actions">
                <div className="item-thumbnail-actions -width-full">
                  <ItemActions
                    item={item}
                    onAddToFavourites={onAddToFavourites}
                    onAddToCollections={onAddToCollections}
                    onAddToCart={onAddToCart}
                    nonAudioTheme
                    transparentTheme
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="product-list__column-price">
          <p className="product-list__price-desktop">${item.ui.price}</p>
          {item.ui.pricePeriod && (
            <p className="fds-c-text-body -size-xs fds-u-m0">
              /{item.ui.pricePeriod}
            </p>
          )}
          <div className="product-list__info-desktop">
            {item.rating.rating ? (
              <StarRating
                rating={item.rating.rating}
                className="star-rating--search"
              />
            ) : null}
            {item.rating.rating ? <br /> : null}
            {item.rating.rating && item.rating.count
              ? `${item.rating.count} ratings`
              : null}
            {item.number_of_sales ? (
              <div className="product-list__sales-desktop">
                <BarChartIcon width="20" height="30" />
                <br />
                {item.number_of_sales ? `${item.number_of_sales} Sales` : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {item.trending && <TrendingSash />}
    </div>
  )
}

export default ItemCardListBigPreview
